import * as React from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Paper from "@mui/material/Paper";
import { Container, Content } from "rsuite";
import { Button } from "@mui/material";
import { ContentPaste, ListAltRounded } from "@mui/icons-material";
import Header from "app/components/Header";
import useAuth from "app/hooks/useAuth";

import { Outlet, useNavigate } from "react-router-dom";
import { IMPORT_PREMIUMPOINT, VIEW_PREMIUMPOINT } from "Permissions";
import { MatxLoading } from "app/components";

export default function PremiumPointNew() {
    const { permissions, user } = useAuth();
    const navigate = useNavigate();

    return (
        <Paper
            elevation={3}
            sx={{
                p: 2,
                m: 1,
                width: "100%",
                borderRadius: 2,
                backgroundColor: "#ffffff",
            }}
        >
            <Stack spacing={2}>
                <Header headerText="Premium Point">
                    {(permissions.includes(VIEW_PREMIUMPOINT) ||
                        user.Type === "SuperAdmin") && (
                        <Button
                            onClick={() => navigate("List")}
                            variant="contained"
                            color="primary"
                            startIcon={<ListAltRounded />}
                            sx={{ borderRadius: 2 }}
                        >
                            List
                        </Button>
                    )}
                    {(permissions.includes(IMPORT_PREMIUMPOINT) ||
                        user.Type === "SuperAdmin") && (
                        <Button
                            onClick={() => navigate("ImportByPaste")}
                            variant="contained"
                            color="secondary"
                            startIcon={<ContentPaste />}
                            sx={{ borderRadius: 2 }}
                        >
                            Paste & Import
                        </Button>
                    )}
                </Header>

                <Container>
                    <Content
                        style={{
                            flex: 1,
                            width: "100%",
                            minHeight: 650,
                            borderRadius: 8,
                            padding: 10,
                            boxShadow: "inset 0 0 10px rgba(0,0,0,0.05)",
                            backgroundColor: "#f9fafc",
                            border: "1px solid #e0e0e0"
                        }}
                    >
                        {navigate.state === "loading" ? <MatxLoading /> : <Outlet />}
                    </Content>
                </Container>
            </Stack>
        </Paper>
    );
}
